import React from "react";
import useStaticDestinationsData from "components/StaticQuery/useStaticDestinationsData";
import Slider, { SliderSlide } from "components/Slider";
import { ComponentBackgroundColor } from "types/componentBackground";
import LinkCard from "components/Card/LinkCard";

interface DestinationsSliderProps {
  cardBackgroundColor?: ComponentBackgroundColor;
  showExpeditionsOnly: boolean;
}

const DestinationsSlider: React.FC<DestinationsSliderProps> = ({
  cardBackgroundColor,
  showExpeditionsOnly = false
}) => {
  const destinations = useStaticDestinationsData({ showExpeditionsOnly });
  return (
    <Slider
      variantColor={cardBackgroundColor}
      data-content-name="destinations_slider"
    >
      {destinations.map((item) => {
        return (
          <SliderSlide key={item.id}>
            <LinkCard
              backgroundColor={cardBackgroundColor}
              key={item._id}
              title={item.card?.title?.localized}
              image={item.card?.image}
              description={item.card?.description?.localized}
              url={item.fullPath}
            />
          </SliderSlide>
        );
      })}
    </Slider>
  );
};

export default DestinationsSlider;
